import React from 'react';
import AddRole from './Add'
import EditRole from './Edit'
import ListRoles from './List'
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import '../style.css'

export default function ManageRoles() {
  let { path } = useRouteMatch();

  return <Switch>
    <Route path={`${path}/edit/:id`} component={EditRole} />
    <Route path={`${path}/add`} component={AddRole} />
    <Route path={`${path}`} component={ListRoles} />
  </Switch>
}